/* eslint-disable */
import projectsModel from '$$projectModel';
import _ from 'lodash';
import taskToXlsxExportHelpers from './helpers/taskToXlsxExportHelpers'
import xlsxExport from "../xlsxExport";
import rights from '../../../components/rights';

const __ = window.__;

const innerObject = {
  init: {
    run: function () { },
    afterInit: function () { }
  },

  handlers: {
    export: async function (options) {
      const serialisedListData = options.data;
      const rows = await innerObject.handlers.prepareTasks(serialisedListData);
      const exportOptions = {
        title: options.title,
        enablePrice: !!rights.project.hasCostRight(projectsModel.getActiveGanttId()),
        worksheets: []
      };

      const columns = taskToXlsxExportHelpers.getTaskColumns(exportOptions, {
        excludedColumns: ['wbs','level'],
      });

      exportOptions.worksheets.push({
        title: exportOptions.title,
        rows,
        columns
      });

      xlsxExport.export(exportOptions);
    },

    prepareTasks: async function (tasks) {
      const result = [];

      _.each(tasks, function (task, index) {
        let preparedTask = taskToXlsxExportHelpers.taskToRow(task, false, { multiProjectsList: true }); 

        let dur = preparedTask.data.duration / 60;
        if(dur && dur/Math.floor(dur) !==1 ){
          dur = dur.toFixed(2);
        }
        preparedTask.data.duration = dur;

        result.push(preparedTask);
      });
      return result;
    },
   }
};

const outputObject = {
  init: {
    run: innerObject.init.run,
    afterInit: innerObject.init.afterInit,
  },
  export: innerObject.handlers.export
};

export default outputObject;

